import type { PathObjectInterface } from '@/map-phaser-new/interfaces'

export const boatBottomToRightPath: PathObjectInterface = {
  mainPath: { x: 1300, y: 2300 },
  spline: [
    1499, 2072, 1701, 1943, 2032, 1835, 2282, 1729, 2836, 1679, 3230, 1576, 3489, 1477, 3715, 1424,
    3900, 1376,
  ],
}
